import {type FC, type FormEvent, useCallback, useEffect, useState} from 'react';
import {
    ActionButton,
    BroadcastWrapper,
    DevicePreviewGrid,
    DevicePreviewItem,
    PageTitle,
    PreparationBox,
    VideoOverlayBar,
    VideoPanel,
} from './types/Broadcast.styled.ts';
import ConfSender from './components/ConfSender.tsx';
import Webcam from 'react-webcam';
import callApi from '../../apis/callApi.ts';
import type {Device} from './types';
import Package from '../../../package.json';

const BroadcastPage: FC = () => {
    const [isDisabledStart, setIsDisabledStart] = useState<boolean>(false);
    const [isDisabledStop, setIsDisabledStop] = useState<boolean>(false);

    const [token, setToken] = useState<string>('');
    const getJWT = async () => {
        const {data} = await callApi().post(`jitsi/token/`, {user: '스튜디오'});
        setToken(data.token.slice(2, -1));
    };
    useEffect(() => {
        getJWT();
    }, []);

    const [devices, setDevices] = useState<Device[]>([]);
    const handleDevices = useCallback((mediaDevices: MediaDeviceInfo[]): void => {
        setDevices(mediaDevices.filter(({kind}) => kind === 'videoinput') as Device[]);
    }, []);
    useEffect(() => {
        if (navigator?.mediaDevices?.enumerateDevices) {
            navigator.mediaDevices.enumerateDevices().then(handleDevices);
        }
    }, [handleDevices]);

    const [renderBroadCast, setRenderBroadCast] = useState<boolean>(false);

    const handleStart = (e: FormEvent): void => {
        e.preventDefault();
        if (isDisabledStart) return;
        setRenderBroadCast(true);
        setIsDisabledStart(true);
        setIsDisabledStop(true);
        setTimeout(() => {
            setIsDisabledStart(false);
            setIsDisabledStop(false);
        }, 3000);
    };

    const handleStop = (e: FormEvent): void => {
        e.preventDefault();
        setRenderBroadCast(false);
    };

    return (
        <BroadcastWrapper>
            <PageTitle>방송 송출 관리</PageTitle>
            <VideoPanel>
                {renderBroadCast ? (
                    <ConfSender token={token}/>
                ) : (
                    <PreparationBox>
                        <h3>방송 송출 준비중입니다.</h3>
                        <h6>(ver. {Package.version})</h6>
                        <DevicePreviewGrid>
                            {devices.map((device, index) => (
                                <DevicePreviewItem key={index}>
                                    <Webcam
                                        audio={false}
                                        videoConstraints={{deviceId: {exact: device.deviceId}}}
                                        style={{height: '300px', borderRadius: '8px'}}
                                    />
                                    <h4>{device.label || `Device ${index + 1}`}</h4>
                                </DevicePreviewItem>
                            ))}
                        </DevicePreviewGrid>
                    </PreparationBox>
                )}
                <VideoOverlayBar>
                    {renderBroadCast ? (
                        <ActionButton $variant="secondary" $disabled={isDisabledStop} onClick={handleStop}>
                            방송 준비 화면으로 나가기
                        </ActionButton>
                    ) : (
                        <ActionButton $variant="primary" $disabled={isDisabledStart} onClick={handleStart}>
                            방송 시작
                        </ActionButton>
                    )}
                </VideoOverlayBar>
            </VideoPanel>
        </BroadcastWrapper>
    );
};

export default BroadcastPage;
